import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <p>2026 &copy; Ertugrul Kücükkaya</p>
    </footer>
  )
}

export default Footer
